<template>

  <b-modal
    v-model="isVisible"
    hide-footer
    size="lg"
  >

    <b-card>

      <h2 class="text-center mb-3">Observaciones de la atencion medica</h2>
      
      {{ comentarios }}

      <div v-if="comentarios.length > 0">
        <v-select
          v-model="estadoRevision"
          :options="estadoRevisionOpts"
          label="text"
          placeholder="Estado de revision de la atencion medica"
        />

        <!-- <b-table
          :items="comentarios" 
          :fields="tableFields"
          class="text-center mt-3"
          responsive small
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template #cell(estadoComentario)="data">
            <span 
              v-if="data.item.estadoComentario === '1'"
              class="text-success"
            >
              Revisado
            </span>
          </template>

          <template #cell(ultimoCambio)="data">
            {{ formatDateToDB(data.item.ultimoCambio) }}
          </template>
        </b-table> -->

        <!-- <b-table
          :items="comentarios" 
          :fields="tableFields"
          class="text-center mt-3"
          responsive small
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template #cell(estadoComentario)="data">
            <span 
              v-if="data.item.estadoComentario === '1'"
              class="text-success"
            >
              Revisado
            </span>
          </template>

          <template #cell(ultimoCambio)="data">
            {{ formatDateToDB(data.item.ultimoCambio) }}
          </template>
        </b-table> -->

        <div class="text-right mt-3">
          <b-button variant="primary">
            Enviar Revision
          </b-button>
        </div>
      </div>

      <EmptyResults v-if="comentarios.length === 0"/>

    </b-card>
    
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import { formatDateToDB } from "@/shared/helpers";
import { EmptyResults } from "@/shared/components";
import { atencionAuditoriaService } from '../../services';


export default {
  name: "AtencionAuditoriaComentarios",

  components: {
    vSelect,
    EmptyResults
  },

  data() {
    return {
      isVisible: false,
      tokenAtencion:null,

      comentarios:[],

      estadoRevision: null,

      estadoRevisionOpts: [
        { value: '0', text: 'Atendida' },    // Acaba de ser atentida por el doctor
        { value: '1', text: 'Por revisar' }, // El auditor ya dio sus comentarios
        { value: '2', text: 'Revisada' },    // El doctor ya corrigio las observaciones del auditor
        { value: '3', text: 'Concluida' },   // El auditor da por terminada la atencion
        { value: '4', text: 'Anulada' },     // El doctor anula la atencion.
        { value: '5', text: 'Auditada' }     // El doctor anula la atencion.
      ],

      tableFields: [
        { 
          key: "index", 
          label: "N°", 
          thClass: "text-center", 
          tdClass: "text-center" 
        },
        { 
          key: "tablaForanea", 
          label: "Campo", 
          thClass: "text-center" 
        },
        { 
          key: "comentario",    
          label: "Comentario",    
          thClass: "text-center",
          tdClass: "text-left"
        },
        { 
          key: "estadoComentario",       
          label: "Estado",       
          thClass: "text-center" 
        },

        { 
          key: "ultimoCambio",       
          label: "Fecha / Hora",       
          thClass: "text-center" 
        },

        { 
          key: "usuarioCreador.username",       
          label: "Auditor",       
          thClass: "text-center" 
        },
      ],

      formatDateToDB: formatDateToDB

    };
  },

  created() {
    this.setToken();
  },


  methods: {


    async onGetDataComments( ){
      console.log('st', this.stRevisiones);
      let data = null;

      if(this.tokenAtencion in this.stRevisiones) {
        data = this.stRevisiones[this.tokenAtencion];
      }

      if (data) this.comentarios = data;

      this.isVisible = true;
    },


    setToken(){
      this.tokenAtencion = this.$route.query.comments;
    }
  },

  watch: {

    '$route.query.comments': {
      handler(){ 
        this.setToken();
      },
    },

    tokenAtencion:{
      deep:true,
      handler(newValue){
        if(!newValue) return;
        this.onGetDataComments( newValue );
      }
    },


    isVisible: {
      deep: true,
      handler(newValue) {
        if( !newValue ) this.$router.push({ name: 'atenciones-medicas' })
      }
    },

  },

  computed: {
    ...mapState({
      stRevisiones: state => state.atencionMedica.auditoria?.revisiones
    }),

  },



};
</script>
